<template>
  <v-app>
    <v-main app class="bg">
      <v-container fluid>
        <v-row>
          <v-col cols="12" class="d-flex justify-center">
            <v-img src="../assets/logo.png" :style="'max-width: 350px; width: 100%; background-color: #000000;'">
            </v-img>
          </v-col>
          <v-col cols="12" class="d-flex justify-center m-0 pt-0 pb-0">
            <hr :style="'width: 90vw;'" />
          </v-col>
        </v-row>
        <v-row v-if="$store.state.alertOn" class="d-flex justify-center">
          <v-col cols="12" lg="6">
            <v-alert border="top" colored-border type="info" elevation="2" dismissible>
              <span v-html="$store.state.alertText.replaceAll('\n', '<br>')">

              </span>
            </v-alert>
          </v-col>
        </v-row>

        <v-row>
          <v-container>
            <v-row no-gutter>
              <v-col cols="3">
                <v-row no-gutter>
                  <v-col cols="12" class="d-flex justify-center pa-1 pt-2"><v-img src="../assets/nav1.png"
                      @click="goTo('/')" :class="'nav-icon-button'"
                      :style="'max-height: 120px; max-width: 120px; width: 100%; height: 100%; cursor: pointer;'">
                    </v-img></v-col>
                  <v-col cols="12" class="d-flex justify-center pa-1"><span :class="'nav-text'">O nas</span></v-col>
                </v-row>
              </v-col>
              <v-col cols="3">
                <v-row no-gutter>
                  <v-col cols="12" class="d-flex justify-center pa-1 pt-2"><v-img src="../assets/nav2.png"
                      @click="goTo('/produkty')" :class="'nav-icon-button'"
                      :style="'max-height: 120px; max-width: 120px; width: 100%; height: 100%; cursor: pointer;'">
                    </v-img></v-col>
                  <v-col cols="12" class="d-flex justify-center pa-1"><span :class="'nav-text'">Produkty</span></v-col>
                </v-row>
              </v-col>
              <v-col cols="3">
                <v-row no-gutter>
                  <v-col cols="12" class="d-flex justify-center pa-1 pt-2"><v-img src="../assets/nav3.png"
                      @click="goTo('/faq')" :class="'nav-icon-button'"
                      :style="'max-height: 120px; max-width: 120px; width: 100%; height: 100%; cursor: pointer;'">
                    </v-img></v-col>
                  <v-col cols="12" class="d-flex justify-center pa-1"><span :class="'nav-text'">FAQ</span></v-col>
                </v-row>
              </v-col>
              <v-col cols="3">
                <v-row no-gutter>
                  <v-col cols="12" class="d-flex justify-center pa-1 pt-2"><v-img src="../assets/nav4.png"
                      @click="goTo('/koszyk')" :class="'nav-icon-button'"
                      :style="'max-height: 120px; max-width: 120px; width: 100%; height: 100%; cursor: pointer;'">
                    </v-img></v-col>
                  <v-col cols="12" class="d-flex justify-center pa-1"><span :class="'nav-text'"
                      v-if="$store.getters.cartSize < 1">Koszyk</span><span :class="'nav-text'" v-else>Koszyk ({{
                        $store.getters.cartSize
                      }})</span></v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-row>
        <v-row class="d-flex justify-center">
          <v-col cols="12" class="d-flex justify-center">
            <v-btn large :color="'#0088cc'" class="no-uppercase">
              <a :href="$store.state.telegramChannel" target="_blank"><span :style="'color: white;'"> <v-icon>fas
                    fa-paper-plane</v-icon>&nbsp;Nasz kanał Telegram</span></a>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
      <v-container fluid>

        <v-container :style="'height: 100%; min-height: 500px; max-height: 1000px;'" :class="!this.$vuetify.breakpoint.mobile
            ? 'leaf-border-landscape border-padding d-flex'
            : 'leaf-border-portrait border-padding  d-flex'
          ">
          <router-view></router-view>
        </v-container>
      </v-container>
      <!-- <Snowf :amount="100" :size="5" :speed="1.5" :wind="0" :opacity="0.8" :swing="1" :image="null" :zIndex="1"
      :resize="true" color="#fff" /> -->
      <!-- <div class="snowflake"></div>
      <div class="snowflake"></div>
      <div class="snowflake"></div>
      <div class="snowflake"></div>
      <div class="snowflake"></div>
      <div class="snowflake"></div>
      <div class="snowflake"></div>
      <div class="snowflake"></div>
      <div class="snowflake"></div>
      <div class="snowflake"></div>
      <div class="snowflake"></div>
      <div class="snowflake"></div>
      <div class="snowflake"></div>
      <div class="snowflake"></div>
      <div class="snowflake"></div>
      <div class="snowflake"></div>
      <div class="snowflake"></div>
      <div class="snowflake"></div>
      <div class="snowflake"></div>
      <div class="snowflake"></div>
      <div class="snowflake"></div>
      <div class="snowflake"></div>
      <div class="snowflake"></div>
      <div class="snowflake"></div>
      <div class="snowflake"></div>
      <div class="snowflake"></div>
      <div class="snowflake"></div>
      <div class="snowflake"></div>
      <div class="snowflake"></div>
      <div class="snowflake"></div>
      <div class="snowflake"></div>
      <div class="snowflake"></div>
      <div class="snowflake"></div>
      <div class="snowflake"></div>
      <div class="snowflake"></div>
      <div class="snowflake"></div>
      <div class="snowflake"></div>
      <div class="snowflake"></div>
      <div class="snowflake"></div>
      <div class="snowflake"></div>
      <div class="snowflake"></div>
      <div class="snowflake"></div>
      <div class="snowflake"></div>
      <div class="snowflake"></div>
      <div class="snowflake"></div>
      <div class="snowflake"></div>
      <div class="snowflake"></div>
      <div class="snowflake"></div>
      <div class="snowflake"></div> -->
    </v-main>

    <v-snackbar v-model="snackbarInfo" :timeout="timeout" dark elevation="24">
      <strong>{{ snackbarInfoText }}</strong>

      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbarInfo = false">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-snackbar v-model="snackbarError" :timeout="timeout" elevation="24" color="red">
      <v-icon>fas fa-exclamation-circle</v-icon> &nbsp;
      <strong color="blue">{{ snackbarErrorText }}</strong>

      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbarError = false">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-snackbar v-model="snackbarSuccess" :timeout="timeout" elevation="24" color="green">
      <v-icon>fas fa-check-circle</v-icon> &nbsp;
      <strong color="white">{{ snackbarSuccessText }}</strong>

      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbarSuccess = false">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

  </v-app>
</template>

<script>

export default {
  name: "default-layout",
  data: () => ({
    timeout: 2000,
    snackbarInfoText: "Notification",
    snackbarInfo: false,
    snackbarErrorText: "Notification",
    snackbarError: false,
    snackbarSuccessText: "Notification",
    snackbarSuccess: false,
  }),
  methods: {
    goTo: function (path) {
      this.$router.push(path);
    },
  },
  components: {

  },
  created: async function () {
    await this.$store.dispatch("fetchCart");
    await this.$store.dispatch("fetchStoreInfo");
  },
};
</script>

<style>
.no-uppercase {
  text-transform: unset !important;
}

.nav-icon-button:hover {
  opacity: 0.8;
  transition: 0.5;
}

@media (max-width: 400px) {
  .border-padding {
    padding-top: 30px;
    padding-bottom: 30px;
    padding-left: 10% !important;
    padding-right: 10% !important;
  }
}

@media (max-width: 600px) {
  .border-padding {
    padding-top: 30px;
    padding-bottom: 30px;
    padding-left: 10% !important;
    padding-right: 10% !important;
  }
}

@media (min-width: 600px) and (max-width: 960px) {
  .border-padding {
    padding-top: 30px;
    padding-bottom: 30px;
    padding-left: 10% !important;
    padding-right: 10% !important;
  }
}

@media (min-width: 960px) and (max-width: 1264px) {
  .border-padding {
    padding-top: 50px;
    padding-bottom: 50px;
    padding-left: 8% !important;
    padding-right: 8% !important;
  }
}

@media (min-width: 1264px) and (max-width: 1904px) {
  .border-padding {
    padding-top: 50px;
    padding-bottom: 50px;
    padding-left: 7% !important;
    padding-right: 7% !important;
  }
}

@media (min-width: 1904px) {
  .border-padding {
    padding-top: 50px;
    padding-bottom: 50px;
    padding-left: 7% !important;
    padding-right: 7% !important;
  }
}

.nav-text {
  color: white;
  font-size: clamp(1.1rem, 2.5vw, 1.5rem) !important;
  font-weight: bold;
}

.leaf-border-landscape {
  background-size: 100% 100%;
  background-image: url("../assets/rect-frame-landscape-filled.png");
}

.leaf-border-portrait {
  background-size: 100% 100%;
  background-image: url("../assets/rect-frame-portrait-filled.png");
}

.bg {
  background-size: cover;
  background-color: #31332f;
  background-image: url("../assets/bg.png");
}


.snowflake {
  --size: 1vw;
  width: var(--size);
  height: var(--size);
  background: white;
  border-radius: 50%;
  position: fixed;
  top: -5vh;
}

@keyframes snowfall {
  0% {
    transform: translate3d(var(--left-ini), 0, 0);
  }

  100% {
    transform: translate3d(var(--left-end), 110vh, 0);
  }
}

.snowflake:nth-child(1) {
  --size: 1vw;
  --left-ini: -3vw;
  --left-end: -6vw;
  left: 66vw;
  animation: snowfall 13s linear infinite;
  animation-delay: -2s;
}

.snowflake:nth-child(2) {
  --size: 0.4vw;
  --left-ini: -5vw;
  --left-end: 6vw;
  left: 43vw;
  animation: snowfall 8s linear infinite;
  animation-delay: -6s;
}

.snowflake:nth-child(3) {
  --size: 0.6vw;
  --left-ini: -2vw;
  --left-end: -9vw;
  left: 10vw;
  animation: snowfall 13s linear infinite;
  animation-delay: -5s;
}

.snowflake:nth-child(4) {
  --size: 0.6vw;
  --left-ini: 3vw;
  --left-end: 4vw;
  left: 32vw;
  animation: snowfall 14s linear infinite;
  animation-delay: -4s;
}

.snowflake:nth-child(5) {
  --size: 0.4vw;
  --left-ini: 3vw;
  --left-end: 10vw;
  left: 17vw;
  animation: snowfall 9s linear infinite;
  animation-delay: -3s;
}

.snowflake:nth-child(6) {
  --size: 0.6vw;
  --left-ini: 2vw;
  --left-end: 2vw;
  left: 23vw;
  animation: snowfall 7s linear infinite;
  animation-delay: -3s;
}

.snowflake:nth-child(7) {
  --size: 0.2vw;
  --left-ini: -1vw;
  --left-end: 2vw;
  left: 62vw;
  animation: snowfall 6s linear infinite;
  animation-delay: -1s;
}

.snowflake:nth-child(8) {
  --size: 1vw;
  --left-ini: -8vw;
  --left-end: 7vw;
  left: 77vw;
  animation: snowfall 7s linear infinite;
  animation-delay: -4s;
}

.snowflake:nth-child(9) {
  --size: 0.8vw;
  --left-ini: -2vw;
  --left-end: 0vw;
  left: 14vw;
  animation: snowfall 8s linear infinite;
  animation-delay: -3s;
}

.snowflake:nth-child(10) {
  --size: 0.6vw;
  --left-ini: -8vw;
  --left-end: 4vw;
  left: 61vw;
  animation: snowfall 8s linear infinite;
  animation-delay: -9s;
}

.snowflake:nth-child(11) {
  --size: 1vw;
  --left-ini: -9vw;
  --left-end: -9vw;
  left: 88vw;
  animation: snowfall 7s linear infinite;
  animation-delay: -8s;
}

.snowflake:nth-child(12) {
  --size: 0.2vw;
  --left-ini: -5vw;
  --left-end: -6vw;
  left: 28vw;
  animation: snowfall 11s linear infinite;
  animation-delay: -8s;
}

.snowflake:nth-child(13) {
  --size: 0.6vw;
  --left-ini: -2vw;
  --left-end: 3vw;
  left: 94vw;
  animation: snowfall 11s linear infinite;
  animation-delay: -3s;
}

.snowflake:nth-child(14) {
  --size: 0.4vw;
  --left-ini: 2vw;
  --left-end: -1vw;
  left: 30vw;
  animation: snowfall 13s linear infinite;
  animation-delay: -9s;
}

.snowflake:nth-child(15) {
  --size: 0.4vw;
  --left-ini: -5vw;
  --left-end: -1vw;
  left: 97vw;
  animation: snowfall 10s linear infinite;
  animation-delay: -2s;
}

.snowflake:nth-child(16) {
  --size: 0.8vw;
  --left-ini: 8vw;
  --left-end: 2vw;
  left: 44vw;
  animation: snowfall 15s linear infinite;
  animation-delay: -10s;
}

.snowflake:nth-child(17) {
  --size: 0.8vw;
  --left-ini: -4vw;
  --left-end: -7vw;
  left: 30vw;
  animation: snowfall 12s linear infinite;
  animation-delay: -9s;
}

.snowflake:nth-child(18) {
  --size: 0.2vw;
  --left-ini: -3vw;
  --left-end: 7vw;
  left: 19vw;
  animation: snowfall 10s linear infinite;
  animation-delay: -9s;
}

.snowflake:nth-child(19) {
  --size: 0.2vw;
  --left-ini: 0vw;
  --left-end: 6vw;
  left: 35vw;
  animation: snowfall 8s linear infinite;
  animation-delay: -2s;
}

.snowflake:nth-child(20) {
  --size: 1vw;
  --left-ini: 2vw;
  --left-end: 4vw;
  left: 88vw;
  animation: snowfall 10s linear infinite;
  animation-delay: -2s;
}

.snowflake:nth-child(21) {
  --size: 0.6vw;
  --left-ini: -7vw;
  --left-end: 7vw;
  left: 11vw;
  animation: snowfall 12s linear infinite;
  animation-delay: -7s;
}

.snowflake:nth-child(22) {
  --size: 0.6vw;
  --left-ini: -5vw;
  --left-end: -3vw;
  left: 65vw;
  animation: snowfall 12s linear infinite;
  animation-delay: -1s;
}

.snowflake:nth-child(23) {
  --size: 0.8vw;
  --left-ini: 3vw;
  --left-end: -3vw;
  left: 67vw;
  animation: snowfall 14s linear infinite;
  animation-delay: -10s;
}

.snowflake:nth-child(24) {
  --size: 0.6vw;
  --left-ini: 5vw;
  --left-end: -8vw;
  left: 33vw;
  animation: snowfall 11s linear infinite;
  animation-delay: -2s;
}

.snowflake:nth-child(25) {
  --size: 0.8vw;
  --left-ini: -9vw;
  --left-end: 1vw;
  left: 7vw;
  animation: snowfall 11s linear infinite;
  animation-delay: -6s;
}

.snowflake:nth-child(26) {
  --size: 0.8vw;
  --left-ini: 2vw;
  --left-end: 10vw;
  left: 49vw;
  animation: snowfall 7s linear infinite;
  animation-delay: -4s;
}

.snowflake:nth-child(27) {
  --size: 0.4vw;
  --left-ini: -3vw;
  --left-end: -6vw;
  left: 18vw;
  animation: snowfall 7s linear infinite;
  animation-delay: -6s;
}

.snowflake:nth-child(28) {
  --size: 1vw;
  --left-ini: 3vw;
  --left-end: -8vw;
  left: 58vw;
  animation: snowfall 10s linear infinite;
  animation-delay: -9s;
}

.snowflake:nth-child(29) {
  --size: 1vw;
  --left-ini: -3vw;
  --left-end: 7vw;
  left: 89vw;
  animation: snowfall 15s linear infinite;
  animation-delay: -10s;
}

.snowflake:nth-child(30) {
  --size: 0.6vw;
  --left-ini: 3vw;
  --left-end: 6vw;
  left: 84vw;
  animation: snowfall 12s linear infinite;
  animation-delay: -10s;
}

.snowflake:nth-child(31) {
  --size: 0.4vw;
  --left-ini: 7vw;
  --left-end: 2vw;
  left: 41vw;
  animation: snowfall 8s linear infinite;
  animation-delay: -5s;
}

.snowflake:nth-child(32) {
  --size: 0.6vw;
  --left-ini: 3vw;
  --left-end: -9vw;
  left: 52vw;
  animation: snowfall 8s linear infinite;
  animation-delay: -7s;
}

.snowflake:nth-child(33) {
  --size: 0.8vw;
  --left-ini: 10vw;
  --left-end: -3vw;
  left: 92vw;
  animation: snowfall 15s linear infinite;
  animation-delay: -5s;
}

.snowflake:nth-child(34) {
  --size: 0.4vw;
  --left-ini: -8vw;
  --left-end: 8vw;
  left: 25vw;
  animation: snowfall 6s linear infinite;
  animation-delay: -8s;
}

.snowflake:nth-child(35) {
  --size: 0.2vw;
  --left-ini: 2vw;
  --left-end: 7vw;
  left: 13vw;
  animation: snowfall 9s linear infinite;
  animation-delay: -3s;
}

.snowflake:nth-child(36) {
  --size: 0.6vw;
  --left-ini: 8vw;
  --left-end: 8vw;
  left: 28vw;
  animation: snowfall 13s linear infinite;
  animation-delay: -6s;
}

.snowflake:nth-child(37) {
  --size: 1vw;
  --left-ini: -3vw;
  --left-end: 4vw;
  left: 32vw;
  animation: snowfall 14s linear infinite;
  animation-delay: -5s;
}

.snowflake:nth-child(38) {
  --size: 0.4vw;
  --left-ini: -3vw;
  --left-end: -3vw;
  left: 47vw;
  animation: snowfall 8s linear infinite;
  animation-delay: -6s;
}

.snowflake:nth-child(39) {
  --size: 0.2vw;
  --left-ini: 0vw;
  --left-end: 7vw;
  left: 86vw;
  animation: snowfall 6s linear infinite;
  animation-delay: -3s;
}

.snowflake:nth-child(40) {
  --size: 1vw;
  --left-ini: 9vw;
  --left-end: 4vw;
  left: 35vw;
  animation: snowfall 13s linear infinite;
  animation-delay: -10s;
}

.snowflake:nth-child(41) {
  --size: 0.8vw;
  --left-ini: 6vw;
  --left-end: -3vw;
  left: 15vw;
  animation: snowfall 7s linear infinite;
  animation-delay: -6s;
}

.snowflake:nth-child(42) {
  --size: 1vw;
  --left-ini: 5vw;
  --left-end: -5vw;
  left: 41vw;
  animation: snowfall 12s linear infinite;
  animation-delay: -10s;
}

.snowflake:nth-child(43) {
  --size: 0.6vw;
  --left-ini: -7vw;
  --left-end: -8vw;
  left: 90vw;
  animation: snowfall 12s linear infinite;
  animation-delay: -10s;
}

.snowflake:nth-child(44) {
  --size: 1vw;
  --left-ini: 7vw;
  --left-end: -3vw;
  left: 90vw;
  animation: snowfall 10s linear infinite;
  animation-delay: -3s;
}

.snowflake:nth-child(45) {
  --size: 0.6vw;
  --left-ini: 6vw;
  --left-end: -4vw;
  left: 97vw;
  animation: snowfall 12s linear infinite;
  animation-delay: -2s;
}

.snowflake:nth-child(46) {
  --size: 0.4vw;
  --left-ini: 1vw;
  --left-end: -3vw;
  left: 10vw;
  animation: snowfall 7s linear infinite;
  animation-delay: -3s;
}

.snowflake:nth-child(47) {
  --size: 1vw;
  --left-ini: -4vw;
  --left-end: 10vw;
  left: 71vw;
  animation: snowfall 12s linear infinite;
  animation-delay: -8s;
}

.snowflake:nth-child(48) {
  --size: 0.4vw;
  --left-ini: -5vw;
  --left-end: -8vw;
  left: 68vw;
  animation: snowfall 7s linear infinite;
  animation-delay: -3s;
}

.snowflake:nth-child(49) {
  --size: 0.2vw;
  --left-ini: -2vw;
  --left-end: 7vw;
  left: 36vw;
  animation: snowfall 7s linear infinite;
  animation-delay: -10s;
}

.snowflake:nth-child(50) {
  --size: 0.6vw;
  --left-ini: 10vw;
  --left-end: 8vw;
  left: 81vw;
  animation: snowfall 12s linear infinite;
  animation-delay: -8s;
}

/* added small blur every 6 snowflakes*/
.snowflake:nth-child(6n) {
  filter: blur(1px);
}
</style>